import {handleError} from '../../common/utils/errorHandling';
import httpClient from '../../common/services/httpClient';
import {PlaceListing} from '../../admin/artisticobjects/types/Place';

class PlacesService {
  public async searchPlaces(organizationalUnitIds?: string[], hierarchyType?: string): Promise<PlaceListing[]> {
    const body = {
      organizationalUnitIds: organizationalUnitIds || [],
      hierarchyType: hierarchyType || 'church'
    };

    return handleError(
      () => httpClient.post<PlaceListing[]>('/search/places', body),
      'Error fetching places:',
      () => []
    );
  }
}

const placesService = new PlacesService();
export default placesService;

